import MessageModal from '@components/Modals/MessageModal'

export const OpenMessageModal = (title, $this, closeEvent) => {
  $this.$emit('close')
  const timeout = 200
  setTimeout(() => {
    $this.$modal.show(MessageModal, { title }, {}, {
      'before-close': () => {
        if (closeEvent) {
          closeEvent()
        }
      },
    })
  }, timeout)
}
